import { ThemeOptions } from '@mui/material';

// import MuiButton from './components/MuiButton';
// import MuiCard from './components/MuiCard';
// import MuiCardActions from './components/MuiCardActions';
// import MuiCardContent from './components/MuiCardContent';
// import MuiCardHeader from './components/MuiCardHeader';
// import MuiChip from './components/MuiChip';
// import MuiCircularProgress from './components/MuiCircularProgress';
// import MuiIconButton from './components/MuiIconButton';
// import MuiInputBase from './components/MuiInputBase';
// import MuiInputLabel from './components/MuiInputLabel';
// import MuiLinearProgress from './components/MuiLinearProgress';
// import MuiLink from './components/MuiLink';
// import MuiListItemIcon from './components/MuiListItemIcon';
// import MuiOutlinedInput from './components/MuiOutlinedInput';
// import MuiPaper from './components/MuiPaper';
// import MuiSelect from './components/MuiSelect';
// import MuiSvgIcon from './components/MuiSvgIcon';
// import MuiTab from './components/MuiTab';
// import MuiTableCell from './components/MuiTableCell';
// import MuiTableHead from './components/MuiTableHead';
// import MuiTablePagination from './components/MuiTablePagination';
// import MuiTableRow from './components/MuiTableRow';
// import MuiToggleButton from './components/MuiToggleButton';
// import MuiTypography from './components/MuiTypography';
// import palette from '../theme/palette';

import MuiButton from './overrides/MuiButton';
import MuiCardContent from './overrides/MuiCardContent';
import MuiCardHeader from './overrides/MuiCardHeader';
import MuiChip from './overrides/MuiChip';
import MuiCircularProgress from './overrides/MuiCircularProgress';
import MuiIconButton from './overrides/MuiIconButton';
import MuiInputBase from './overrides/MuiInputBase';
import MuiInputLabel from './overrides/MuiInputLabel';
import MuiLinearProgress from './overrides/MuiLinearProgress';
import MuiLink from './overrides/MuiLink';
import MuiListItemIcon from './overrides/MuiListItemIcon';
import MuiOutlinedInput from './overrides/MuiOutlinedInput';
import MuiPaper from './overrides/MuiPaper';
import MuiSelect from './overrides/MuiSelect';
import MuiSvgIcon from './overrides/MuiSvgIcon';
import MuiTab from './overrides/MuiTab';
import MuiTableCell from './overrides/MuiTableCell';
import MuiTableHead from './overrides/MuiTableHead';
import MuiTablePagination from './overrides/MuiTablePagination';
import MuiTableRow from './overrides/MuiTableRow';
import MuiToggleButton from './overrides/MuiToggleButton';
import MuiToggleButtonGroup from './overrides/MuiToggleButtonGroup';
import MuiTypography from './overrides/MuiTypography';

/**
 * TODO: we need to migrate eventually from ./theme to this
 */
const baseTheme: ThemeOptions = {
	typography: {
		fontFamily: ['Poppins', 'sans-serif'].join(', '),
		h1: {
			fontWeight: 500,
			fontSize: '35px',
			letterSpacing: '-0.24px',
			lineHeight: '40px',
		},
		h2: {
			fontWeight: 500,
			fontSize: '29px',
			letterSpacing: '-0.24px',
			lineHeight: '32px',
		},
		h3: {
			fontWeight: 500,
			fontSize: '24px',
			letterSpacing: '-0.06px',
			lineHeight: '28px',
		},
		h4: {
			fontWeight: 500,
			fontSize: '20px',
			letterSpacing: '-0.06px',
			lineHeight: '24px',
		},
		h5: {
			fontWeight: 500,
			fontSize: '16px',
			letterSpacing: '-0.05px',
			lineHeight: '20px',
		},
		h6: {
			fontWeight: 500,
			fontSize: '14px',
			letterSpacing: '-0.05px',
			lineHeight: '20px',
		},
		subtitle1: {
			fontSize: '16px',
			letterSpacing: '-0.05px',
			lineHeight: '25px',
		},
		subtitle2: {
			fontWeight: 400,
			fontSize: '14px',
			letterSpacing: '-0.05px',
			lineHeight: '21px',
		},
		body1: {
			fontSize: '14px',
			letterSpacing: '-0.05px',
			lineHeight: '21px',
		},
		body2: {
			fontSize: '12px',
			letterSpacing: '-0.04px',
			lineHeight: '18px',
		},
		body3: {
			fontSize: '12px',
			letterSpacing: '-0.04px',
			lineHeight: '18px',
		},
		link1: {
			fontSize: '12px',
			fontWeight: 500,
			letterSpacing: '-0.04px',
			lineHeight: '18px',
		},
		button: {
			fontSize: '14px',
		},
		caption: {
			opacity: 0.9,
			fontSize: '11px',
			letterSpacing: '0.33px',
			lineHeight: '13px',
		},
		overline: {
			fontSize: '11px',
			fontWeight: 500,
			letterSpacing: '0.33px',
			lineHeight: '13px',
			textTransform: 'uppercase',
		},
		label: {
			fontSize: '11px',
			fontWeight: 500,
			letterSpacing: '0.33px',
			lineHeight: '13px',
		},
		pagination: {
			fontSize: '11px',
			fontWeight: 500,
			letterSpacing: '0.33px',
			lineHeight: '13px',
		},
		input: {
			fontSize: 12,
			fontWeight: 500,
			letterSpacing: '-0.04px',
			lineHeight: '18px',
		},
		helperText: {
			fontSize: '11px',
			letterSpacing: '0.37px',
			lineHeight: '16px',
		},
		tooltip: {
			fontWeight: 400,
			fontSize: '12px',
			letterSpacing: '-0.04px',
			lineHeight: '18px',
		},
	},
	components: {
		MuiButton: MuiButton,
		// MuiCard: MuiCard,
		// MuiCardActions: MuiCardActions, // unimported
		MuiCardContent: MuiCardContent,
		MuiCardHeader: MuiCardHeader,
		MuiChip: MuiChip,
		MuiCircularProgress: MuiCircularProgress,
		MuiIconButton: MuiIconButton,
		MuiInputBase: MuiInputBase,
		MuiInputLabel: MuiInputLabel,
		MuiLinearProgress: MuiLinearProgress,
		MuiLink: MuiLink,
		MuiListItemIcon: MuiListItemIcon,
		MuiOutlinedInput: MuiOutlinedInput,
		MuiPaper: MuiPaper,
		MuiSelect: MuiSelect,
		MuiSvgIcon: MuiSvgIcon,
		MuiTab: MuiTab,
		MuiTableCell: MuiTableCell,
		MuiTableHead: MuiTableHead,
		MuiTablePagination: MuiTablePagination,
		// MuiTableRow: MuiTableRow,
		// MuiToggleButton: MuiToggleButton,
		// MuiToggleButtonGroup: MuiToggleButtonGroup,
		MuiTypography: MuiTypography,

		// Notice! This should be temporary as it solves a known bug in mui where
		// the modal doesn't close but is on the page with an opacity=0. Once mui
		// solves this issue, this can be removed
		// See: https://github.com/mui/material-ui/issues/32286
		MuiBackdrop: {
			styleOverrides: {
				root: {
					'&[style*="opacity: 0"]': {
						pointerEvents: 'none',
					},
				},
			},
		},
	},
};

export default baseTheme;
